import { render, staticRenderFns } from "./YellowAI.vue?vue&type=template&id=01557f4f&"
import script from "./YellowAI.vue?vue&type=script&lang=js&"
export * from "./YellowAI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports